import { getTestIds } from 'seagull/utils/TestIds';
import { PdfViewerModal } from "../../PdfViewerModal/pdfViewerModal";
import RichTextViewerModal from "../../RichTextViewerModal";
import { useOverlayContext } from "../../../contexts";
import { useStoreActions } from "../../../store/store-context";

// Helper to remove PDF suffix, fallback to a no-op if not available
import { jsx as _jsx } from "react/jsx-runtime";
function removePDFsuffix(name) {
  if (name !== null && name !== void 0 && name.toLowerCase().endsWith('.pdf')) {
    return name.slice(0, -4);
  }
  return name;
}
export const {
  UseViewLegalTermsTID
} = getTestIds();
export const useViewLegalTerms = () => {
  const {
    api
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  return {
    async viewLegalTerms(selectedOption, sourceId) {
      const {
        name,
        pdfUniqueName,
        richTextContent,
        richTextId
      } = selectedOption;
      if (!name) return;
      if (pdfUniqueName) {
        await overlayContext.showModal({
          content: _ref => {
            let {
              dismissModal
            } = _ref;
            return /*#__PURE__*/_jsx(PdfViewerModal, {
              "data-testid": UseViewLegalTermsTID.PdfViewerModal(),
              title: removePDFsuffix(name),
              getFileUrl: async () => await api.business.getLegalTermsDownloadURL(pdfUniqueName),
              onClose: dismissModal,
              pdfUniqueName: pdfUniqueName
            });
          }
        });
      } else if (richTextContent || richTextId) {
        await overlayContext.showModal({
          content: _ref2 => {
            let {
              dismissModal
            } = _ref2;
            return /*#__PURE__*/_jsx(RichTextViewerModal, {
              show: true,
              title: removePDFsuffix(name),
              text: richTextContent,
              queryKey: richTextId,
              fetchText: async () => {
                if (sourceId && richTextId) {
                  const {
                    value
                  } = await api.texts.getLegalTermsRichTextContent(sourceId, richTextId);
                  return value;
                }
                return richTextContent;
              },
              onClose: dismissModal
            });
          }
        });
      }
    }
  };
};